import { Injectable } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root'
})
export class BodyReactionService<BodyReaction> extends SupabaseDatabaseService<BodyReaction> {
  
  async getByBodyReactionLabel(label: string): Promise<BodyReaction>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.BODY_REACTIONS)
    .select('*')
    .eq('label', label.trim())
    .maybeSingle();

    if (error) {
      console.error(`Erro ao buscar Body Reaction com o label ${label} em '${TYPES.DATABASE.TABLES.BODY_REACTIONS}':`,
        error);
      throw new Error(error.message);
    }
    return (data as BodyReaction);

  }

  async getAllSystemBodyReactions(): Promise<BodyReaction[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.BODY_REACTIONS)
    .select('*')
    .eq('provider', 'system');

    if (error) {
      console.error(`Erro ao buscar System Body Reactions em '${TYPES.DATABASE.TABLES.BODY_REACTIONS}':`,
        error);
      throw new Error(error.message);
    }
    return (data as BodyReaction[]) || [];

  }
  
  async getAllCustomBodyReactionsFromUser(userId: string): Promise<BodyReaction[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.BODY_REACTIONS)
    .select(`
      id,
      label,
      provider,
      created_at,
      updated_at,
      users_body_reactions!inner(user_id)
    `)
    .eq('provider', 'custom')
    .eq('users_body_reactions.user_id', userId);

    if (error) {
      console.error(`Erro ao buscar Custom Body Reactions em '${TYPES.DATABASE.TABLES.BODY_REACTIONS}':`,
        error);
      throw new Error(error.message);
    }
    return (data as BodyReaction[]) || [];

  }

  async deleteBodyReactionFromUser(bodyReactionId: string, userId: string): Promise<void> {
    const { error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.USERS_BODY_REACTIONS)
      .delete()
      .eq('user_id', userId)
      .eq('body_reaction_id', bodyReactionId);

    if (error) {
      console.error(`Erro ao deletar body reaction '${bodyReactionId}' from user ${userId}:`, error);
      throw new Error(error.message);
    }
  }

}
